import {
  MenuItems as HeadlessUIMenuItems,
  MenuItemsProps as HeadlessUiMenuItemsProps,
} from '@headlessui/react';
import { forwardRef } from 'react';

type MenuItemsProps = Omit<
  HeadlessUiMenuItemsProps,
  'className' | 'transition'
>;

export const MenuItems = forwardRef<HTMLElement, MenuItemsProps>(
  (props, ref) => {
    return (
      <HeadlessUIMenuItems
        ref={ref}
        {...props}
        className="z-[1000] w-64 rounded-md bg-white shadow-lg outline-teal-600 ring-1 ring-black/5 transition duration-100 ease-out data-[closed]:scale-95 data-[closed]:opacity-0"
        transition
      />
    );
  },
);
MenuItems.displayName = 'MenuItems';
